import React, { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { useLoading } from '../context/LoadingContext';
import '../styles/PageTransition.css';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const { isLoading, setIsLoading, loaderText } = useLoading();
  const [displayChildren, setDisplayChildren] = React.useState(children);
  const [transitionStage, setTransitionStage] = React.useState('fadeIn');

  // When location changes, trigger the loading animation
  // Update displayed children when actual children change
  // When location changes, trigger the loading animation
  // Update displayed children when actual children change
  useEffect(() => {
    if (isLoading) {
      setTransitionStage('fadeOut');
      
      // After a short delay, update the displayed children
      const timeout = setTimeout(() => {
        setDisplayChildren(children);
        setTransitionStage('fadeIn');
        
        // After the fade-in animation completes, hide the loader
        const hideLoader = setTimeout(() => {
          setIsLoading(false);
        }, 1200); // Using 1200ms as requested
        
        return () => clearTimeout(hideLoader);
      }, 1200); // This is for the content transition
      
      return () => clearTimeout(timeout);
    } else {
      setDisplayChildren(children);
    }
  }, [children, isLoading, setIsLoading]);

  return (
    <div className={`page-transition ${transitionStage}`}>
      {displayChildren}
      
      {isLoading && (
        <div className="page-loader">
          <div className="loader-container">
            <img
              src="/graphics/Main LOGO 1 transparent.png"
              alt="SpitFire Logo"
              className="loader-logo"
            />
            <div className="loader-text">{loaderText}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageTransition;